// Third party modules;
import React from 'react';

// HelpBot modules;
import './App.css';
import app from './app';
import View from './View';

const AskHenry = (props) => {

   const [state, set_state] = React.useState(app.state_string);

   app.Init(set_state);

   return( 
      <app.state_context.Provider value={[state]}>
        <View />
      </app.state_context.Provider>
   );

} // AskHenry();

export default AskHenry;
